"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export function Selector(_a) {
    var className = _a.className, itemClassName = _a.itemClassName, items = _a.items, _b = _a.selected, selection = _b === void 0 ? undefined : _b, focused = _a.focused, _c = _a.multi, multi = _c === void 0 ? false : _c, renderItem = _a.renderItem, onChange = _a.onChange, onSelect = _a.onSelect, onClickItem = _a.onClickItem, computeSelected = _a.computeSelected;
    var _d = __read(useState(selection || {}), 2), selected = _d[0], setSelected = _d[1];
    useEffect(function () {
        setSelected(selection || {});
    }, [selection]);
    return (_jsx("ul", { className: className, children: items.map(function (item) { return (_jsx("li", { className: itemClassName, onClick: function () {
                select(item);
                onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem();
            }, children: (item === null || item === void 0 ? void 0 : item.id) && renderItem(item, selected[item.id], focused === item.id) }, item.id)); }) }));
    function select(item) {
        var _a, _b, _c;
        if (!item.id)
            return;
        var next;
        if (multi) {
            next = __assign(__assign({}, selected), (_a = {}, _a[item.id] = !selected[item.id], _a));
        }
        else {
            next = (computeSelected === null || computeSelected === void 0 ? void 0 : computeSelected((_b = {}, _b[item.id] = !selected[item.id], _b))) || (_c = {},
                _c[item.id] = !selected[item.id],
                _c);
        }
        setSelected(next);
        onChange === null || onChange === void 0 ? void 0 : onChange(next);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(item);
    }
}
